// Mock data for Intellexa website
// This will be replaced with actual API calls when backend is implemented

export const mockData = {
  hero: {
    title: "Intellexa",
    subtitle: "Your End-to-End Technology Partner",
    description: "Transforming businesses through Data Science, AI/ML, and modern web development solutions.",
    backgroundImage: "https://images.unsplash.com/photo-1674027444485-cec3da58eef4",
    cta: {
      primary: "Get Started",
      secondary: "Learn More"
    }
  },

  services: [
    {
      id: 1,
      title: "Data Science & Analytics",
      description: "Unlock the power of your data with advanced analytics, predictive modeling, and data-driven insights that drive business growth.",
      icon: "BarChart3",
      image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa"
    },
    {
      id: 2,
      title: "AI & Machine Learning",
      description: "Build intelligent systems that learn and adapt. From computer vision to NLP, we create AI solutions that solve real-world problems.",
      icon: "Brain",
      image: "https://images.unsplash.com/photo-1697577418970-95d99b5a55cf"
    },
    {
      id: 3,
      title: "Modern Web Development",
      description: "Create stunning, responsive web applications with cutting-edge technologies. Fast, scalable, and built for the future.",
      icon: "Code2",
      image: "https://images.unsplash.com/photo-1531297484001-80022131f5a1"
    },
    {
      id: 4,
      title: "Cloud Solutions",
      description: "Deploy and scale your applications with confidence. We architect cloud-native solutions optimized for performance and cost.",
      icon: "Cloud",
      image: "https://images.pexels.com/photos/5311522/pexels-photo-5311522.jpeg"
    },
    {
      id: 5,
      title: "DevOps & Automation",
      description: "Streamline your development pipeline with CI/CD, infrastructure as code, and automated testing frameworks.",
      icon: "Workflow",
      image: "https://images.pexels.com/photos/4389462/pexels-photo-4389462.jpeg"
    },
    {
      id: 6,
      title: "Consulting & Strategy",
      description: "Navigate your digital transformation journey with expert guidance on technology strategy and implementation.",
      icon: "Lightbulb",
      image: "https://images.unsplash.com/photo-1644088379091-d574269d422f"
    }
  ],

  // Products
  // To add a new product, append another object to this array.
  // `image` should be a screenshot of the product's website landing page.
  products: [
    {
      id: 1,
      name: "GrowWise",
      description: "A learning platform that blends gamified lessons, AI tutoring, and real-time progress tracking. Streaks, XP, and badges keep students motivated, while teachers and parents follow every step of the journey.",
      image: "/growwise.jpg",
      url: "https://growwise-2.onrender.com/"
    },
    {
      id: 2,
      name: "Finexa AI",
      description: "Smarter finance and billing for modern businesses. Create GST-ready invoices, track real-time cash flow and MRR, and uncover hidden revenue insights with an AI-powered financial assistant.",
      image: "/finexa.png",
      url: "https://finexa-1-efo8.onrender.com/"
    }
  ],

  technologies: [
    {
      id: 1,
      category: "Data & AI",
      items: ["Python", "TensorFlow", "PyTorch", "Scikit-learn", "Pandas", "Apache Spark"]
    },
    {
      id: 2,
      category: "Web Development",
      items: ["React", "Node.js", "Next.js", "TypeScript", "Vue.js", "FastAPI"]
    },
    {
      id: 3,
      category: "Cloud & DevOps",
      items: ["AWS", "Azure", "GCP", "Docker", "Kubernetes", "Terraform"]
    },
    {
      id: 4,
      category: "Databases",
      items: ["PostgreSQL", "MongoDB", "Redis", "Elasticsearch", "MySQL", "DynamoDB"]
    }
  ],

  team: [
    {
      id: 1,
      name: "Chidanandh N A",
      // role: "Chief Executive Officer",
      // bio: "Big on vision and steady in the storm, turns bold ideas into real world impact and makes it look easier than it is.",
      image: "/Chidanandh_N_A.png",
      linkedin: "https://www.linkedin.com/in/chidanandh/"
    },
    {
      id: 2,
      name: "Varada N M",
      // role: "Chief Technology Officer",
      // bio: "Equal parts thinker and tinkerer, turning complex tech into things that actually work and work well.",
      image: "/Varada.jpg",
      linkedin: "https://www.linkedin.com/in/varada-n-m-128aa8217/"
    },
    
    // {
    //   id: 3,
    //   name: "Haifa Abdul Sathar",
    //   // role: "Product Manager",
    //   // bio: "The calm in the chaos, connecting ideas, people, and possibilities into products that just click.",
    //   image: "/Haifa.jpeg",
    //   linkedin: "https://www.linkedin.com/in/haifa-abdul-sathar-0a26a52a8/"
    // },
    {
      id: 4,
      name: "Arun Suresh Babu",
      // role: "Head of Growth & Strategy",
      // bio: "Always asking “what’s next?” while quietly building the path to get there.",      
      image: "/Arun.jpeg",
      linkedin: "https://www.linkedin.com/in/arunsureshbabu/"
    },
    {
      id: 5,
      name: "Harikrishnan",
      // role: "Lead Backend Developer",
      // bio: "Works behind the scenes, keeping everything fast, stable, and one step ahead of breaking.",      
      image: "/Hari.jpg",
      linkedin: "https://www.linkedin.com/in/hari-krishnan007/"
    },
    {
      id: 6,
      name: "Asha Vakkattil",
      // role: "Lead Frontend Developer ",
      // bio: "Sweats the details so users don’t have to, and makes great design feel effortless.",      
      image: "/Asha.jpg",
      linkedin: "https://www.linkedin.com/in/asha-vakkattil-a9110b1b4/"
    }
  ],

  testimonials: [
    {
      id: 1,
      name: "Emily Johnson",
      role: "CEO, TechVision Inc.",
      content: "Intellexa transformed our data infrastructure and built predictive models that increased our revenue by 40%. Their expertise is unmatched.",
      rating: 5
    },
    {
      id: 2,
      name: "David Kim",
      role: "CTO, DataFlow Systems",
      content: "The team's ability to understand complex requirements and deliver scalable solutions is impressive. They're true technology partners.",
      rating: 5
    },
    {
      id: 3,
      name: "Lisa Martinez",
      role: "VP Product, AI Innovations",
      content: "Working with Intellexa was seamless. They delivered our ML platform ahead of schedule and exceeded all our expectations.",
      rating: 5
    }
  ],

  contact: {
    email: "intellexa.tech@gmail.com",
    phone: "+91 090748 33161",
    // address: "123 Tech Avenue, San Francisco, CA 94105",
    social: {
      linkedin: "https://www.linkedin.com/in/intellexa-tech-328180404/",
      twitter: "https://x.com/IntellexaTech",
      github: "https://github.com/intellexatech-sketch"
    }
  },

  stats: [
    { label: "Projects Delivered", value: "250+" },
    { label: "Happy Clients", value: "150+" },
    { label: "Team Members", value: "50+" },
    { label: "Countries Served", value: "25+" }
  ]
};

// Mock API functions that will be replaced with actual API calls
export const mockAPI = {
  getHeroData: () => Promise.resolve(mockData.hero),
  getServices: () => Promise.resolve(mockData.services),
  getProducts: () => Promise.resolve(mockData.products),
  getTechnologies: () => Promise.resolve(mockData.technologies),
  getTeam: () => Promise.resolve(mockData.team),
  getTestimonials: () => Promise.resolve(mockData.testimonials),
  getContactInfo: () => Promise.resolve(mockData.contact),
  getStats: () => Promise.resolve(mockData.stats),
  
  submitContactForm: (formData) => {
    // Simulate API call
    console.log('Contact form submitted (mock):', formData);
    return Promise.resolve({ 
      success: true, 
      message: 'Thank you! We will get back to you soon.' 
    });
  }
};